<template>
 <div>
      <app-Channels >
        <table >
            <tr  v-for="(channel, index) in channels" :key="channel.code" @click.prevent="clicked(index)">
            <td style="width: 87.7805%;" class="channels-name">{{ channel.name }}</td>
            <td style="width: 15.2195%;" class="channels-code">{{ channel.code }}</td>
            </tr>
        </table> 
  </app-channels>
 </div>
</template>

<script>
import Channels from './Channels.vue';

export default {
    props: ['channels'],
    components: {
        appChannels:Channels,

    },
    methods:{
        clicked(index){
            this.$emit('channelClicked', index);
        }
    }
}
</script>

<style>
.channels-name{
    font-size: 16px;
    font-weight: 400;
}

.channels-code{
    font-size: 16px;
    font-weight: 900;
}
table tr {
    border-bottom: 1px solid #dee2e61a;
    color: #a2abbd;
    border-top:unset;
    cursor: pointer;
}
table tr:last-of-type{
    border-bottom:unset;
}
table tr td{
        padding-top: 10px;
        padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChannelsPreview.vue